import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import CountUp from 'react-countup';
import Helmet from 'react-helmet';
import _ from 'lodash';
import ua from 'ua-parser-js';
import {Line,Pie} from 'react-chartjs-2';
import General from '../../modules/General';
import moment from 'moment';
import Helpers from '../../../../lib/helpers';

class Dashboard extends React.Component {
	constructor(props) {
		super(props);

		this.interval = null;
		this.updateStatsInterval = null;

		this.state = {
			total_cart_sum:0,
			total_visitors:0,
			known_visitors:0,
			referrer:[],
			mobile:0,
			score:[],
			desktop:0,
			popularPages:[],
            popularProducts:[],
			interval:null,
            orders:{},
            subtotal:{},
            average_subtotal_sum:0,
            average_total_orders:0,
            today_subtotal_sum:0,
            today_total_orders:0,
            week_subtotal_sum:0,
            week_total_orders:0,
			total_carts:0,


        }

        this.options = {
            responsiveAnimationDuration:0,
            showLines:true,
            responsive:true,
            animation: {
                duration:0
            },
            legend: {
                display:false,
            },
            scales: {
                xAxes: [{
                    ticks: {
                        display: false
                    },
                    gridLines: {
                        display:false
                    },
                    display:false
                }],
                yAxes: [{
                    display:false,
                    ticks: {
                        display: false
                    },
                    gridLines: {
                        display:false
                    }
                }]
            }
        };



		this.oldState = {
			...this.state
		};

		this.placeholderSize = 80;
		this.recalculate = this.recalculate.bind(this);
		this.renderPopularPages = this.renderPopularPages.bind(this);
		this.renderMostValuableCustomer = this.renderMostValuableCustomer.bind(this);
	}

	renderRevenueBySourceTable() {
        let data = this.placeholderRow(4,4);

        for(let i in this.state.referrer) {
            data[i] = (
				<tr key={i} className={`${this.blurry()}`}>
					<td>{(parseInt(i)+1)}.</td>
					<td>{this.state.referrer[i].referrer}</td>
					<td>{this.state.referrer[i].sum}</td>
					<td>{this.state.referrer[i].orders}</td>

				</tr>
            );
        }

        return data;
	}

	hasPackage = () => {
        return false;
	}

	blurry = () => {
		if(this.hasPackage()) {
			return '';
		}

		return 'blurred';
	}

	renderRevenueBySource() {
		return (
			<div className="card-block p-0">
				<div className={(this.state.referrer.length == 0 ? 'col-sm-12':'col-sm-7')}>
					<table className={`table ${(this.state.referrer.length == 0 ? '':'split-right')}`}>
						<thead>
						<tr>
							<th>
								#
							</th>
							<th>
								Source
							</th>
							<th>
								Sum
							</th>
							<th>
								Number of orders
							</th>
						</tr>
						</thead>
						<tbody>
						{this.renderRevenueBySourceTable()}
						</tbody>
					</table>
				</div>

				{this.state.referrer.length > 0 ?
					<div className="col-sm-5">
                        {this.renderRevenueBySourceGraph()}
					</div>:null}

			</div>
		)

	}

	renderRevenueBySourceGraph() {
		let labels = [];
		let orders = [];

		for(let i in this.state.referrer) {
            labels.push(this.state.referrer[i].referrer);
            orders.push(this.state.referrer[i].raw);
		}

        const data = {
            labels: labels,
            datasets: [{
                data: orders,
                backgroundColor: [
                    '#FA9898',
                    '#A2CAEE',
                    '#7DD3AE',
					'#F8E59B'
                ],
                hoverBackgroundColor: [
                    '#FA9898',
                    '#A2CAEE',
                    '#7DD3AE',
					'#F8E59B'
                ]
            }]
        };

		let options = {
            responsive:true,
            animation:{
                animateScale:false
            },
            legend: {
            	labels: {

				}
            },
            tooltips: {
                enabled:false
			}
    }

		return  <Pie data={data} height={100} options={options} />
	}

	renderWeeklyOrderGraph() {

	    let orders = [];
	    let haveData = false;

	    for(let i in this.state.orders) {
	        if(this.state.orders[i] != 0) {
	            haveData = true;
            }
	        orders.push(this.state.orders[i]);
        }

        //if(!haveData) {
	        return null;
        //}

        const data = {
            labels: Object.keys(this.state.orders),
            datasets: [
                {
                    label: 'Orders: ',
                    fill: true,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(42, 54, 60,0.5)',
                    borderColor: 'rgba(42, 54, 60,0.5)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(42, 54, 60,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 0,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: orders
                }
            ]
        };

	    return <Line data={data} height={100}  options={this.options} />;
    }

    renderWeeklySubtotalGraph() {

        let orders = [];
        let haveData = false;

        for(let i in this.state.subtotal) {
            if(this.state.subtotal[i] != 0) {
                haveData = true;
            }
            orders.push(this.state.subtotal[i]);
        }

        //if(!haveData) {
            return null
        //}

        const data = {
            labels: Object.keys(this.state.subtotal),
            datasets: [
                {
                    label: 'Orders: ',
                    fill: true,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(42, 54, 60,0.5)',
                    borderColor: 'rgba(42, 54, 60,0.5)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(42, 54, 60,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: '#ffffff',
                    pointHoverBorderColor: '#ffffff',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: orders
                }
            ]
        };

        return <Line data={data} height={100}  options={this.options} />;
    }


    placeholder() {
		return <span className="tag tag-default" style={{display:'inline-block',width:'35%'}}>&nbsp;</span>;
	}

	placeholderRow(rows,cols) {
		let td = [];
		for(let i = 1;i<=cols;i++) {
			td.push(<td key={i}>{this.placeholder()}</td>);
		}

		let row = [];
		for(let i = 1;i<=rows;i++) {
			row.push(<tr key={i}>{td}</tr>);
		}

		return row;
	}

	renderScore(score) {
		let color = '';

	    if(score > 90) {
	        color = '#cc0000';
	    }else if(score > 80) {
	        color = '#ff0000';
	    }else if(score > 50) {
	        color = '#ff3300';
	    }else if(score > 20) {
	        color = '#ff5c33';
	    }else{
	        color = '#000000';
	    }

	    return <span style={{color:color}}>{score}</span>;
	}

	renderMostValuableCustomer() {
		let data = this.placeholderRow(5,6);

		let dataCounter = 0;
		for(let i in this.state.score) {

			if(this.state.score[i].online === 0) {
				continue;
			}

			data[dataCounter] = (
				<tr key={this.state.score[i].uid} className={`${this.blurry()}`}>
					<td>{this.state.score[i].name ? this.state.score[i].name
						:
                        this.state.score[i].email !== "" && typeof this.state.score[i].email === 'string' ? this.state.score[i].email : 'Unknown'
					}</td>
					<td>
						{
							parseInt(this.state.score[i].isMobile) === 0 ?
							<i className="icon fa-desktop" style={{fontSize:'20px'}} aria-hidden="true"></i>
							:
							<i className="icon fa-mobile-phone" style={{fontSize:'20px'}} aria-hidden="true"></i>
						}
					</td>
					<td>{this.state.score[i].path}</td>
					<td>-</td>
					<td>{this.state.score[i].cart_total}</td>
					<td>
						{
							this.hasPackage() ?
                                <Link to={General.Link(`/chat/${this.props.auth.user.id}/${this.state.score[i].uid}`)} className="btn btn-sm btn-dark btn-icon"><i className="icon wb-chat"></i></Link>
								:
								null
						}
					</td>
				</tr>
			);

            dataCounter = dataCounter+1;
        }

		return data;
	}

    renderPopularProducts() {
        let data = this.placeholderRow(5,2);

        for(let i in this.state.popularProducts) {
            data[i] = (
				<tr key={i} className={`${this.blurry()}`}>
					<td>{this.state.popularProducts[i].name}</td>
					<td>{this.state.popularProducts[i].count}</td>
				</tr>
            );
        }
        return data;
	}

	renderPopularPages() {
		let data = this.placeholderRow(5,3);

		for(let i in this.state.popularPages) {
			data[i] = (
				<tr key={i} className={`counter-number ${this.blurry()}`}>
					<td>{this.state.popularPages[i].title}</td>
					<td>{this.state.popularPages[i].path}</td>
					<td>{this.state.popularPages[i].visitors}</td>
				</tr>
			);
		}
		return data;
	}


	recalculate() {
		let cart_sum = 0;
		let mobile = 0;
		let desktop = 0;
		let visitors = 0;
		let pages = [];
		let products = []
		let known = 0;
		let score = [];
		let total_carts = 0;

        for(let i in this.props.chat.cart) {
            let cart = this.props.chat.cart[i];
            let visitor = this.props.chat.visitors[i];

            if(typeof this.props.chat.visitors[i] !== 'undefined') {
                if(visitor.online === 0) {
                    continue;
                }
			}


            for (let pI in cart) {
                let found_p = false;
                for (let pI2 in products) {
                    if (products[pI2].id == cart[pI].id) {
                        products[pI2].count = (parseInt(cart[pI].quantity) + products[pI2].count);
                        found_p = true;
                    }
                }

                if (!found_p) {
                    products.push({
                        name: cart[pI].name,
                        id: cart[pI].id,
                        count: parseInt(cart[pI].quantity)
                    });
                }


            }
        }

		for(let i in this.props.chat.visitors) {
			let visitor = this.props.chat.visitors[i];

			if(visitor.online === 0) {
				continue;
			}
			cart_sum += parseInt(visitor.cart_total);

			if(parseInt(visitor.cart_total) > 0) {
				total_carts++;
			}
			visitors++;
			if(visitor.isMobile === 1) {
				mobile++;
			}else{
				desktop++;
			}

			if(visitor.email !== "" && typeof visitor.email === 'string') {
				known++;
			}

			let found_page = false;
			for(let pI in pages) {
				if(pages[pI].path == visitor.path) {
					pages[pI].visitors++;
					found_page = true;
				}
			}
			if(!found_page) {
				pages.push({
					url:visitor.url,
					path:visitor.path,
					title:visitor.page_title,
					visitors:1,
				});
			}
		}

		pages = _.sortBy(pages, 'visitors').reverse();
		pages = pages.slice(0,5);

        products = _.sortBy(products, 'count').reverse();
        products = products.slice(0,5);

		score = _.sortBy(this.props.chat.visitors, 'score').reverse();
		score = _.filter(score, function(visitor) {
			return visitor.online === 1;
		});
		score = score.slice(0,5);

		if(desktop > 0) {
			desktop = desktop*100/visitors;
			desktop = Math.floor(desktop);
			mobile = 100-desktop;
		}

		if(known > 0) {
			known = known*100/visitors;
		}




		this.oldState = {
			...this.state
		}

		this.setState({
			total_cart_sum:cart_sum,
			total_visitors:visitors,
			known_visitors:known,
			popularPages:pages,
			popularProducts:products,
			score:score,
			desktop:desktop,
			mobile:mobile,
			total_carts:total_carts
		});



	}

	componentWillUnmount() {
	    clearInterval(this.interval);
	    clearInterval(this.updateStatsInterval);
/*
		this.setState({
			interval:null,
		});*/
	}


	componentDidMount() {
		this.recalculate();
		this.interval = setInterval(this.recalculate,3400);
		this.updateStatsInterval = setInterval(this.updateStats,30000);
/*
        this.setState({
            interval:intervalID,
        });*/

		this.updateStats();


	}

	updateStats = () => {
        let today = moment().format();
        axios.get('/orders/stats?date='+encodeURIComponent(today)).then(res => {
            this.setState({
                referrer:res.data.referrer,
                orders:res.data.orders,
                subtotal:res.data.subtotal,
                average_subtotal_sum:res.data.average_subtotal_sum,
                average_total_orders:res.data.average_total_orders,
                today_subtotal_sum:res.data.today_subtotal_sum,
                today_total_orders:res.data.today_total_orders,
                week_subtotal_sum:res.data.week_subtotal_sum,
                week_total_orders:res.data.week_total_orders,
            })
        });
	}

	render() {

        return (

                        <div style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(241, 244, 245, 0.8705882352941177)',
                            zIndex: 999,
                        }}>
                            <div className="row">
                                <div className="col-sm-12 text-center">
                                    <h3>Kontrollpanelet er flyttet</h3>


                                    <div style={{display:'flex',justifyContent:'center',width:'100%'}}><button onClick={() => Helpers.redirectToNewAdmin()} style={{width:'200px'}}className="btn btn-success btn-icon btn-block">Gå til nytt kontrollpanel</button></div>

                                </div>  
                            </div>
                        </div>
        )


		return (
			<div id="dashboard" className="page-content">
				<Helmet title="Dashboard | Crall.io" />

				{
					this.hasPackage() ?
						null:
                        <div style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(241, 244, 245, 0.8705882352941177)',
                            zIndex: 999,
                        }}>
                            <div className="row">
                                <div className="col-sm-12 text-center">
                                    <h3>Kontrollpanelet er flyttet</h3>

                                    <h5>
                                        This page will show you live customer data from your store. How much each customer has in their cart, what products are popular and what pages they're browsing.
                                    </h5>

                                    <h5>
                                        You don't have access to this feature. You need to subscribe to the "Platform Package" to gain access.
                                    </h5>
                                </div>
                            </div>
                        </div>
				}

				<div className="row">
				<div className="col-sm-3">
					<div className="card card-block p-30">
						<div className="card-watermark blue-grey-500 font-size-60 m-15">
							<i className="icon wb-shopping-cart" aria-hidden="true"></i>
						</div>
						<div className="counter counter-md counter-inverse text-xs-left">
							<div className="counter-number-group ">
							<span className={`counter-number blue-grey-500 ${this.blurry()}`}><CountUp start={this.oldState.total_cart_sum} end={this.state.total_cart_sum} duration={2} /></span>
							</div>
							<div className="cart-total">{this.state.total_carts > 0 ? this.state.total_carts:null}</div>
							<div className="counter-label blue-grey-500 text-capitalize">total cart sum</div>
						</div>
					</div>
				</div>



				<div className="col-sm-3">
					<div className="card card-block p-30">
						<div className="card-watermark blue-grey-500 font-size-60 m-15">
							<i className="icon wb-eye" aria-hidden="true"></i>
						</div>
						<div className="counter counter-md counter-inverse text-xs-left">
							<div className="counter-number-group ">
							<span className={`counter-number blue-grey-500 ${this.blurry()}`}><CountUp start={this.oldState.total_visitors} end={this.state.total_visitors} duration={2} /></span>
							</div>
							<div className="counter-label blue-grey-500 text-capitalize">Active visitors</div>
						</div>
					</div>
				</div>





				<div className="col-sm-3">
					<div className="card card-block p-30">
						<div className="card-watermark blue-grey-500 font-size-60 m-15">
							<i className="icon wb-user-circle" aria-hidden="true"></i>
						</div>
						<div className="counter counter-md counter-inverse text-xs-left">
							<div className="counter-number-group ">
							<span className="counter-number blue-grey-500">
								<div className="progress progress-xl m-b-10" style={{height:'37px'}}>
									<div className="progress-bar progress-bar-striped progress-bar-info bg-blue-600" style={{width:this.state.known_visitors+'%'}} aria-valuenow="70.3" aria-valuemin="0" aria-valuemax="100" role="progressbar">
									</div>
								</div>
							</span>
							</div>
							<div className="counter-label blue-grey-500 text-capitalize">Known visitors</div>
						</div>
					</div>
				</div>






				<div className="col-sm-3">
					<div className="card card-block p-30">
						<div className="card-watermark blue-grey-500 font-size-60 m-15">
							<i className="icon wb-desktop" aria-hidden="true"></i>
						</div>
						<div className="counter counter-md counter-inverse text-xs-left">
							<div className="counter-number-group ">
							<span className="counter-number blue-grey-500">

								<div className="progress progress-xl m-b-10" style={{height:'37px'}}>
									<div className="progress-bar progress-bar-primary progress-bar-striped" style={{width:this.state.mobile+'%'}} role="progressbar">
									</div>
									<div className="progress-bar progress-bar-success progress-bar-striped" style={{width:this.state.desktop+'%'}} role="progressbar">
									</div>
								</div>


							</span>
							</div>
							<div className="counter-label blue-grey-500 text-capitalize">
								<span className="margin-left-15 font-weight-400">
									<i className="fa fa-square" style={{color:'#62a8ea'}} aria-hidden="true"></i> Mobile / &nbsp;&nbsp;
									<i className="fa fa-square" style={{color:'#46be8a'}} aria-hidden="true"></i> Desktop
								</span>
							</div>
						</div>
					</div>
				</div>
				</div>

				<div className="row">
                <div className="col-sm-6">
                    <div className="card card-shadow p-0">
                        <div className="card-header card-header-transparent card-header-bordered">
                            <button type="button" className="btn btn-sm btn-dark">
                                <i className="icon wb-graph-up"></i>
                            </button>
                            <span className="m-l-15 font-weight-400">Weekly orders</span>
                        </div>
                        <div className="card-header card-header-transparent card-header-bordered">
                            <div className="row">
                                <div className="col-xs-4">
                                    <div className="counter counter-sm">
                                        <div className="counter-label text-uppercase">Today</div>
                                        <div className="counter-number-group">
                                            <span className={`counter-number green-600 ${this.blurry()}`}>{this.state.today_total_orders}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-4">
                                    <div className="counter counter-sm">
                                        <div className="counter-label text-uppercase">Average</div>
                                        <div className="counter-number-group">
                                            <span className={`counter-number green-600 ${this.blurry()}`}>{this.state.average_total_orders}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-4">
                                    <div className="counter counter-sm">
                                        <div className="counter-label text-uppercase">Week</div>
                                        <div className="counter-number-group">
                                            <span className={`counter-number green-600 ${this.blurry()}`}>{this.state.week_total_orders}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-block p-0">
                            {this.renderWeeklyOrderGraph()}
                        </div>
                    </div>
                </div>

                <div className="col-sm-6">
                    <div className="card card-shadow p-0">
                        <div className="card-header card-header-transparent card-header-bordered">
                            <button type="button" className="btn btn-sm btn-dark">
                                <i className="icon wb-graph-up"></i>
                            </button>
                            <span className="m-l-15 font-weight-400">Weekly order sum</span>
                        </div>
                        <div className="card-header card-header-transparent card-header-bordered">
                            <div className="row">
                                <div className="col-xs-4">
                                    <div className="counter counter-sm">
                                        <div className="counter-label text-uppercase">Today</div>
                                        <div className="counter-number-group">
                                            <span className={`counter-number green-600 ${this.blurry()}`}>{this.state.today_subtotal_sum}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-4">
                                    <div className="counter counter-sm">
                                        <div className="counter-label text-uppercase">Average</div>
                                        <div className="counter-number-group">
                                            <span className={`counter-number green-600 ${this.blurry()}`}>{this.state.average_subtotal_sum}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-4">
                                    <div className="counter counter-sm">
                                        <div className="counter-label text-uppercase">Week</div>
                                        <div className="counter-number-group">
                                            <span className={`counter-number green-600 ${this.blurry()}`}>{this.state.week_subtotal_sum}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-block p-0">
                            {this.renderWeeklySubtotalGraph()}
                        </div>
                    </div>
                </div>
				</div>

				<div className="row">
				<div className="col-sm-12">
					<div className="card card-shadow p-0">
						<div className="card-header card-header-transparent card-header-bordered">
							<button type="button" className="btn btn-sm btn-dark">
								<i className="icon wb-shopping-cart"></i>
							</button>
							<span className="m-l-15 font-weight-400">Most valuable customers right now</span>
						</div>
						<div className="card-block p-0">
							<table className="table">
								<thead>
									<tr>
										<th>
											Customer name
										</th>
										<th>
											Device
										</th>
										<th>
											Page
										</th>
										<th>
											Latest order
										</th>
										<th>
											Cart sum
										</th>
										<th>
											Actions
										</th>
									</tr>
								</thead>
								<tbody>
									{this.renderMostValuableCustomer()}
								</tbody>
							</table>
						</div>
					</div>
				</div>
				</div>



				<div className="row">
					<div className="col-sm-12">
						<div className="card card-shadow p-0">
							<div className="card-header card-header-transparent card-header-bordered">
								<button type="button" className="btn btn-sm btn-dark">
									<i className="icon wb-link"></i>
								</button>
								<span className="m-l-15 font-weight-400">Top 5 revenue sources</span>
							</div>
                            {this.renderRevenueBySource()}
						</div>
					</div>
				</div>



				<div className="row">
				<div className="col-sm-12">

					<div className="card card-shadow p-0">
						<div className="card-header card-header-transparent card-header-bordered">
							<button type="button" className="btn btn-sm btn-dark">
								<i className="icon wb-users"></i>
							</button>
							<span className="m-l-15 font-weight-400">Most popular pages right now</span>
						</div>
						<div className="card-block p-0">
							<table className="table">
								<thead>
									<tr>
										<th>
											Page
										</th>
										<th>
											Url
										</th>
										<th>
											Visitors
										</th>
									</tr>
								</thead>
								<tbody>
									{this.renderPopularPages()}
								</tbody>
							</table>
						</div>
					</div>
				</div>
				</div>



				<div className="row">
					<div className="col-sm-12">

						<div className="card card-shadow p-0">
							<div className="card-header card-header-transparent card-header-bordered">
								<button type="button" className="btn btn-sm btn-dark">
									<i className="icon wb-users"></i>
								</button>
								<span className="m-l-15 font-weight-400">Most popular products right now</span>
							</div>
							<div className="card-block p-0">
								<table className="table">
									<thead>
									<tr>
										<th>
											Name
										</th>
										<th>
											Quantity
										</th>
									</tr>
									</thead>
									<tbody>
                                    {this.renderPopularProducts()}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>


			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general,
		chat:state.chat,
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


Dashboard = connect(mapStateToProps,mapDispatchToProps)(Dashboard);
export default Dashboard;



// WEBPACK FOOTER //
// ./containers/dashboard/dashboard.js